import { useContactStore } from '../../store/contactStore'
import { ALL_SPECIES_BUCKETS, SPECIES_LABELS } from '../../constants/taxonomy'
import type { SpeciesBucket } from '../../types/contact'

export default function SpeciesFilter() {
  const { filters, toggleSpeciesBucket, setFilters } = useContactStore()
  const active = filters.species_buckets

  return (
    <div className="flex flex-wrap gap-1.5 px-3 py-2">
      {ALL_SPECIES_BUCKETS.map((bucket: SpeciesBucket) => {
        const isActive = active.length === 0 || active.includes(bucket)
        return (
          <button
            key={bucket}
            type="button"
            onClick={() => toggleSpeciesBucket(bucket)}
            className={`px-2 py-1 rounded-full text-xs font-medium border transition-all ${
              isActive
                ? 'text-gray-800 border-gray-400 bg-gray-100 opacity-100'
                : 'text-gray-400 border-gray-200 opacity-50 hover:opacity-80'
            }`}
            title={`${isActive ? 'Hide' : 'Show'} ${SPECIES_LABELS[bucket]}`}
          >
            {SPECIES_LABELS[bucket]}
          </button>
        )
      })}
      {active.length > 0 && (
        <button
          type="button"
          onClick={() => setFilters({ species_buckets: [] })}
          className="text-xs text-gray-500 hover:text-gray-700 px-2 py-1 transition-colors"
        >
          Clear
        </button>
      )}
    </div>
  )
}
